const { createContext, useState, useRef } = require('react');

const FeedbackContext = createContext();


export const FeedbackProvider = ({children}) => {
    const [currentMessage, setCurrentMessage] = useState(false);
    const [messageQueueLength, setMessageQueueLength] = useState(0);

    let messageQueue = useRef([]);
    let timeoutTimer = useRef(false);
    let startQueueBlocker = useRef(0);

    const setMessage = (message) => {
        setCurrentMessage(message);
    }

    const queueMessage = (message) => {
        messageQueue.current.push(message);
        setMessageQueueLength(prev => (prev+1));
        
        if(startQueueBlocker.current === 0){
            startQueue(message);
        }

    }

    const startQueue = (message) => {
        startQueueBlocker.current = 1;
        if(!timeoutTimer.current){

            messageQueue.current.shift();
            setMessageQueueLength(prev => prev-1);

            setMessage(message);

            setTimer()
        }


    }

    const setTimer = () => {
        timeoutTimer.current = setTimeout(() => {
            if(messageQueue.current.length !== 0) {
                // setMessage(false);
                let pendingMessage = messageQueue.current[0];

                messageQueue.current.shift();
                setMessageQueueLength(prev => prev-1);
                setMessage(pendingMessage);
                setTimer();
            }
            else{
                startQueueBlocker.current = 0;
                setMessage(false);
                timeoutTimer.current = false;
            }
            
            
        }, 15250);
    }

    const resetTimer = () => {
        let currentTimeout = timeoutTimer.current;
        clearTimeout(currentTimeout);
        timeoutTimer.current = 0;
        if(messageQueue.current.length !== 0){
            // setTimer();
            startQueueBlocker.current = 0
            startQueue(messageQueue.current[0]);
        }
        else{
            startQueueBlocker.current = 0;
            setMessage(false);
            timeoutTimer.current = false;
        }


    }

    const clearAll = () => {
        startQueueBlocker.current = 0;
        messageQueue.current = [];
        clearTimeout(timeoutTimer.current)
        timeoutTimer.current = false;
        setMessage(false);
        setMessageQueueLength(0);
        setCurrentMessage(false)
    }

    const getQueueLength = () => { 
        return messageQueueLength;
    }


    return(
        <FeedbackContext.Provider value={{currentMessage, queueMessage, resetTimer, getQueueLength, clearAll}}>
            {children}
        </FeedbackContext.Provider>
    )
} 


export default FeedbackContext;